import css from "./ProgressBar.module.scss";

export interface ProgressBarProps {
  max: number;
  value: number;
}

export const ProgressBar = ({ value, max }: ProgressBarProps) => {
  const percentage = (value / max) * 100;

  return (
    <div className={css.progressBar}>
      <div className={css.track}>
        <div className={css.fill} style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
};
